// Simplified Chinese (Mainland) translation generated on 2025-11-04
// 本文件基于英文版并参考繁体（香港）版本转写为中国大陆用语（简体中文）。如需进一步本地化，请按需校对。
export const common = {
  "home.awards.title": "奖项荣誉",
  "home.awards.pause": "暂停奖项轮播",
  "home.awards.play": "播放奖项轮播",
  "home.awards.financialAlgorithm": "金融算法领军企业",
  "home.awards.asiaPacificGold": "亚太黄金交易领军品牌",
  "home.awards.preciousMetals": "贵金属交易公信力品牌",
  "home.awards.digitalFinance": "数字金融创新贡献企业",
  "home.awards.quantitativeTrading": "量化交易技术优秀企业",
  // 导航
  'nav.home': '首页',
  'nav.trading': '交易',
  'nav.markets': '市场',
  'nav.news': '新闻',
  'nav.about': '关于',
  'nav.contact': '联系',
  'nav.login': '登录',
  'nav.register': '注册',
    'nav.license': '牌照资质',
  // 首屏
  'hero.title': '高端黄金与白银交易平台',
  'hero.subtitle': '香港持牌公司，为全球投资者提供安全、专业的贵金属交易服务',
  'hero.cta.start': '开始交易',
  'hero.cta.learn': '下载MT5',

  // 首页
  'home.licenseHK': '香港持牌',
  'home.bankSec': '银行级安全',
  'home.247s': '24/7 客服',
  'home.global': '全球视野',
  'home.tradingPlat': '交易平台',
  'home.tradingWith': '强大稳健的',
  'home.exp': '体验专为贵金属打造的世界级交易平台。MT5 提供机构级工具、闪电级执行，以及全面的市场分析功能。',
  'home.dlMT5': '下载 MT5',
  'home.watchDemo': '观看示范',

  'home.tradingIns': '交易产品',
  'home.exeSpeed': '执行速度',
  'home.mktAccess': '市场接入',
  'home.uptime': '在线率',
  'home.allDevices': '适用于所有设备',

  'home.mktInt': '市场资讯',
  'home.mktInt.desc': '实时掌握影响贵金属交易的经济事件与市场新闻',
  'home.lastUpdate': '最后更新',
  'home.ecoCal': '经济日历',
  'home.refresh': '刷新',
  'home.currency': '货币',
  'home.events': '事件',
  'home.previous': '前值',
  'home.forecast': '预测',
  'home.actual': '实际',
  'home.mktNews': '市场新闻',
  'home.seeMore': '查看更多',
  'home.ecoData': '经济数据由多个金融数据提供商提供 • 市场新闻来自顶级金融媒体',

  'home.ac': '高级图表功能',
  'home.pta': '提供超过 80 种技术指标与分析工具的专业技术分析',
  'home.mpa': '多平台访问',
  'home.tsa': '可于桌面版、网页版及手机应用无缝交易',
  'home.st': '安全交易',
  'home.bls': '银行级加密技术，保障数据传输与存储安全',
  'home.247': '全天候市场接入',
  'home.rtc': '随时随地连接全球贵金属市场进行交易',
  'home.at': '自动化交易',
  'home.ea': '支持智能交易系统（EA），实现算法与自动化策略',
  'home.lfe': '闪电级执行',
  'home.ull': '超低延迟下单，提供具竞争力的点差与即时成交',

  // 特性
  'features.title': '为什么选择我们的平台',
  'features.security.title': '银行级安全',
  'features.security.desc': '先进加密与多层安全机制，保障您的投资',
  'features.licensed.title': '全面持牌',
  'features.licensed.desc': '受香港监管，合规透明',
  'features.realtime.title': '实时交易',
  'features.realtime.desc': '实时市场数据与瞬时执行，把握最佳交易机会',
  'features.support.title': '24/7 客服',
  'features.support.desc': '专业多语团队全年无休为您服务',
  'features.lmd': '实时市场数据',
  'features.rtp': '贵金属实时价格',

  // 市场
  'markets.title': '实时市场价格',
  'markets.gold': '黄金',
  'markets.silver': '白银',
  'markets.platinum': '铂金',
  'markets.palladium': '钯金',
  'markets.price': '价格',
  'markets.change': '变动',
  'markets.high': '24h 高位',
  'markets.low': '24h 低位',
  'markets.contractDetials': '合约详情',
  'markets.contractDetials.desc': '贵金属的全面合约规格与交易条件',
  'markets.tradingExample': '交易示例',
  'markets.goldExample': '黄金交易示例',
  'markets.silverExample': '白银交易示例',
  'markets.instrument': '品种',
  'markets.lotSize': '手数',
  'markets.entPrice': '入场价',
  'markets.marReq': '所需保证金',
  'markets.pip': '点值',
  'markets.pmt': '贵金属交易',
  'markets.ctt': '全面了解贵金属交易的条款、条件与规格；掌握合约详情、保证金要求及风险管理要点，以支持黄金与白银投资。',
  'markets.vts': '查看交易规格',
  'markets.dcd': '下载合约详情',
  'markets.ec': '执行速度',
  'markets.th': '交易时间',
  'markets.ms': '最小点差（pips）',
  'markets.ml': '最高杠杆',
  'markets.mr': '保证金要求',
  'markets.lo': '不同账户类型的杠杆选项与保证金要求',
  'markets.leverage': '杠杆',
  'markets.margin': '保证金',
  'markets.mind': '最低入金',
  'markets.mc': '保证金计算器',
  'markets.gmc': '黄金保证金计算',
  'markets.cp': '当前价格',
  'markets.cv': '合约价值',
  'markets.smc': '白银保证金计算',
  'markets.rm': '风险管理',
  'markets.crm': '以全面工具与策略保护您的投资',
  'markets.rtg': '风险承受度指南',
  'markets.rd': '风险披露',
  'markets.tpm': '贵金属交易存在重大亏损风险，未必适合所有投资者。过往表现不代表未来结果。',
  'markets.lcw': '杠杆既可带来利润，也可能扩大亏损。做出交易决定前，请审慎考虑投资目标、经验水平及风险承受度。',
  'markets.ysb': '请充分了解与贵金属交易相关的所有风险；如有疑问，请咨询独立财务顾问。',
  'markets.rfr': '阅读完整风险披露',
  'markets.cra': '联系风险顾问',
  'markets.tho': '交易时间',
  'markets.moh': '贵金属市场的运行时间与假期安排',
  'markets.wts': '每周交易时间表',
  'markets.note': '注意',
  'markets.atad': '所有时间均以 GMT+8 显示。在主要假期或高波动期间，交易可能暂停。',
  'markets.hs': '假期安排',
  'markets.mclo': '市场休市',
  'markets.eclo': '提前收市',
  'markets.hn': '假期通告',
  'markets.thm': '法定节假日期间，交易时间可能调整；请留意我们的公告。',
  'markets.cms': '当前市场状态',
  'markets.mac': '市场目前开放交易',
  'markets.st': '服务器时间（GMT+8）',
  'markets.ts': '交易规格',
  'markets.dtc': '黄金与白银品种的详细交易条件与规格',
  'markets.msp': '最小点差',
  'markets.minls': '最小手数',
  'markets.maxls': '最大手数',
  'markets.commission': '佣金',
  'markets.sls': '隔夜利息（多／空）',
  'markets.in': '重要提示',
  'markets.smv': '在高波动或重大新闻期间，点差可能扩大',
  'markets.sra': '隔夜利息每日更新，可能因市况改变',
  'markets.mlm': '重大新闻时，最高杠杆可能被下调',
  'markets.ata': '所有时间以 GMT+0 显示',

  // 新闻
  'news.title': '最新市场新闻与分析',
  'news.subtitle': '紧贴专家观点与市场动态',
  'news.readMore': '阅读更多',
  'news.category.analysis': '市场分析',
  'news.category.news': '突发新闻',
  'news.category.insights': '专家观点',
  'news.category.education': '教育',
  'news.date': '发布时间',
  'news.author': '作者',

  // 口碑
  'home.partners.title': '合作伙伴',
  'home.partners.subtitle': '与全球领先的流动性、金融科技及交易基础设施供应商合作。',
  'testimonials.title': '深受全球投资者信赖',
  'testimonials.client1.name': 'Marcus Weber',
  'testimonials.client1.location': '德国 • 法兰克福',
  'testimonials.client1.text': '平台报价透明、执行可靠，安全功能让我充满信心。',
  'testimonials.client2.name': 'Sophie Dubois',
  'testimonials.client2.location': '法国 • 巴黎',
  'testimonials.client2.text': '专业服务与具竞争力点差；多语支持团队非常给力。',
  'testimonials.client3.name': 'Alessandro Rossi',
  'testimonials.client3.location': '意大利 • 米兰',
  'testimonials.client3.text': '执行迅速、分析工具出色，值得认真进行贵金属交易的人推荐。',

  // 页脚
  'footer.company': '公司',
  'footer.trading': '交易',
  'footer.support': '支持',
  'footer.legal': '法律',
  'footer.about': '关于我们',
  'footer.careers': '招聘',
  'footer.news': '新闻',
  'footer.platforms': '交易平台',
  'footer.education': '教育',
  'footer.analysis': '市场分析',
  'footer.help': '帮助中心',
  'footer.contact': '联系我们',
  'footer.faq': '常见问题',
  'footer.terms': '服务条款',
  'footer.privacy': '隐私政策',
  'footer.risk': '风险披露',
  'footer.copyright': '© 2024 GOLD Label Global Limited. 版权所有。',
  'footer.license': "在香港注册成立的公司",
  'footer.riskwarning': '风险提示',
  'footer.disclaimer': '保证金交易属于杠杆式金融产品，可能导致损失超过您的存款。您并不实际拥有或持有任何相关基础资产。交易前请仔细阅读本公司的《风险披露声明》。请务必充分了解涉及的风险，并审慎管理风险敞口。基于本网站或其内容而作出的任何行动或不作为所导致的结果，本公司概不承担任何责任。',
  'footer.jurisdiction': "司法管辖区声明",
  'footer.jurisdictionDisclaimer': "本网站所述服务仅向香港及美国以外司法管辖区内的合资格客户提供，并以客户所在地的适用法律允许提供该等服务为前提。服务不向香港或美国居民提供，也不向任何所在地法律或法规禁止提供该等服务的人士提供。本网站并非面向任何受限制司法管辖区的人士，亦不构成向该等人士作出任何要约、招揽或建议。",
  'footer.relatedEntity': '其他相关实体',
  'footer.saintLuciaEntity': 'Gold Label Global (SL) Limited 为在圣卢西亚注册成立的国际商业公司，成立日期为 2026 年 9 月 4 日，公司注册编号为 2026-00680。注册办事处：Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia。该注册办事处仅为履行法定及监管合规要求而设，并非公司的实际营业场所，也不用于运营、客户到访或通信。',
  'footer.regNo': '公司注册编号',

  // 通用
  'common.language': '语言',
  'common.loading': '加载中…',
  'common.error': '错误',
  'common.success': '成功',
  'common.close': '关闭',
  'common.save': '保存',
  'common.cancel': '取消',
  'common.continue': '继续',
  'common.back': '返回',
  'common.next': '下一步',
  'common.previous': '上一页',
  'common.submit': '提交',
  'common.reset': '重置',

  // 关于
  'about.yearsOfExp': '多年经验',
  'about.yearsOfExp.desc': '在贵金属交易领域累积数十年专业',
  'about.dailyTrade': '每日交易量',
  'about.dailyTrade.desc': '香港每日黄金与白银成交达 800 亿港元',
  'about.satClients': '客户满意度',
  'about.satClients.desc': '服务遍及全球的众多客户与机构',
  'about.exeSpeed': '执行速度',
  'about.exeSpeed.desc': '闪电级交易执行技术',
  'about.ourAch': '我们的成就',
  'about.ourAch.desc': '以业界领先的表现，屡获肯定',
  'about.companyProfile': '公司简介',
  'about.about1': '关于 Gold Label Global',
  'about.about2': 'Gold Label Global Limited 为香港政府核准之有限公司，同时亦为香港黄金交易所成员。香港每日处理价值约 800 亿港元之金银交易，经验领先全球。',
  'about.about3': 'Gold Label Global 管理团队在金银交易领域专注逾二十年，曾服务无数客户与机构，所处理的客户交易金额以数百亿计，深获客户与业界专业人士高度评价。',
  'about.about4': '我们致力为客户提供快速、稳定与优质的交易环境；技术上采用国际级交易系统，并由顶尖技术团队开发更强大与更全面的交易方案，使交易速度更快、更稳、更全面。',
  'about.about5': 'Gold Label Global 将继续与您共创收益、共享繁荣。',
  'about.about6': '探索我们在贵金属交易之路上的成长，以及我们对全球金融市场卓越表现的承诺。',
  'about.about7': '作为香港政府核准之有限公司及香港黄金交易所成员，我们每日处理约 800 亿港元的金银交易，交易经验领先全球。',
  'about.proTeam': '专业团队',
  'about.proTeam.desc': '管理团队深耕金银交易超过 20 年，服务众多客户与机构。',
  'about.proService': '专业服务',
  'about.proService.desc': '专业客服团队提供 24 小时在线与移动客服，并就客户问题提供针对性方案。',
  'about.sec': '安全至上',
  'about.sec.desc': '无交易对手风险，订单直入市场，交易公开透明，更安全可靠。',
  'about.strict': '严格监管',
  'about.strict.desc': 'Gold Label Global 为香港商业交易场所，受香港政府监管，亦为香港商业交易协会成员。',
  'about.fastDes': '快速入金',
  'about.fastDes.desc': '提供 24 小时业务服务，秒级入金，即开即用。',
  'about.productSafe': '产品安全',
  'about.productSafe.desc': '涵盖全球主要贵金属产品，安全可靠。',
  'about.whyGLB': '为什么选择 Gold Label Global',
  'about.whyGLB.desc': '了解我们在贵金属交易领域成为首选的关键优势',
  'about.readyToStart': '准备好开始交易了吗？',
  'about.join': '加入成千上万信任 GOLD Label Global 的满意客户行列，满足您的贵金属交易需求。',
  'about.openTradingAcc': '开立交易账户',
  'about.contactTeam': '联系我们的团队',
  'about.co': '合作共赢',
  'about.co.desc': '与客户与利益相关者建立互利的长期伙伴关系',
  'about.safety': '安全保障',
  'about.safety.desc': '确保所有交易活动达到最高安全标准',
  'about.integrity': '诚信正直',
  'about.integrity.desc': '秉持最高诚信与透明度标准',
  'about.professional': '专业',
  'about.professional.desc': '以无与伦比的专业度提供卓越服务',
  'about.fast': '快速',
  'about.fast.desc': '提供迅速执行与即时响应的客户服务',
  'about.coreValue': '我们的核心价值',
  'about.coreValue.desc': '指引我们在贵金属交易领域追求卓越的核心准则',

  // 联系
  'contact.sendUsMsg': '给我们发送消息',
  'contact.fillOut': '请填写以下表格，我们的团队将在 24 小时内回复您。',
  'contact.inqType': '咨询类型',
  'contact.genInq': '一般咨询',
  'contact.accSup': '账户支持',
  'contact.traSup': '交易支持',
  'contact.techSup': '技术支持',
  'contact.partner': '合作伙伴',
  'contact.fullname': '全名 *',
  'contact.email': '邮箱地址 *',
  'contact.phone': '电话号码',
  'contact.subject': '主题 *',
  'contact.msg': '消息 *',
  'contact.sendMsg': '发送消息',
  'contact.whyUs': '为什么选择我们？',
  'contact.regSec': '受监管与安全',
  'contact.licAndReg': '受监管且安全的交易环境，并以先进安全措施保障您的投资。',
  'contact.expSup': '专家支持',
  'contact.proService': '专业交易专员 24/7 随时协助您的交易需求与问题。',
  'contact.fastExe': '快速执行',
  'contact.lightFast': '闪电级下单执行，滑点极低，实现最佳交易表现。',
  'contact.glbNet': '全球市场',
  'contact.asscessToint': '连接国际贵金属市场，具竞争力点差与深度流动性。',
  'contact.followUs': '关注我们的社交媒体：',
  'contact.contactOutPro': '如需交易支持、账户协助或一般咨询，请联系专业团队：',
  'contact.officeAddress': '办公地址',
  'contact.bussHour': '办公时间：周一至周五 9:00–18:00（GMT+8）',
  'contact.phoneSupp': '电话支持',
  'contact.mainOffice': '总办事处',
  'contact.availableServices': '可提供的服务：',
  'contact.accOpenSup': '开户支持',
  'contact.tradSup': '交易平台协助',
  'contact.genSup': '一般支持',
  'contact.emailSup': '邮箱支持',
  'contact.responseTime': '回复时间：',
  'contact.genInq24': '一般咨询：24 小时内',
  'contact.techSup24': '技术支持：4 小时内',
  'contact.accIss24': '账户问题：2 小时内',
  'contact.needImSup': '需要即时协助？',
  'contact.needImSup.desc': '我们的交易专员 24/7 随时为您处理紧急交易事宜与账户支持。',
  'contact.callNow': '立即致电',
  'contact.sendEmail': '发送邮件',

  'contact.contactUs': '联系我们',
  'contact.getInTouch': '与我们的专业交易团队联系；我们致力协助您在贵金属交易中取得成功。',
  'contact.247Sup': '24/7 客服',
  'contact.247Sup.desc': '全天候为您的所有交易需求提供服务',
  'contact.dirLine': '直线专线',
  'contact.dirLine.desc': '直接与我们的交易专员对话',
  'contact.hkOffice': '香港办事处',
  'contact.hkOffice.desc': '位于香港金融核心地带',

  // 平台
  'platform.wco': '为什么选择我们的 MT5 平台？',
  'platform.rts': '准备好开始交易了吗？',
  'platform.jto': '成千上万交易者信任我们的平台进行贵金属交易',
  'platform.ola': '开立真实账户',
  'platform.tda': '试用模拟账户',

  'platform.dmt': '下载 MT5 平台',
  'platform.ayt': '通过多端 MT5 应用在任何设备登录并管理您的交易账户',
  'platform.free': '免费',
  'platform.dn': '立即下载',
  'platform.sr': '系统需求',
  'platform.nh': '需要入门协助？',
  'platform.os': '我们的支持团队随时协助您设置并开始交易',
  'platform.ug': '使用指南',
  'platform.cs': '联系支持',
  'platform.si': '需要稳定的网络连接',
  'platform.ptf': '强大交易功能',
  'platform.epg': '专为新手与专业交易者设计的专业级工具',
  'platform.ac': '高级图表',
  'platform.pct': '专业图表工具，内置 80+ 技术指标与多种时间框架，助您全面分析市场。',
  'platform.lfe': '闪电级执行',
  'platform.ull': '超低延迟交易，最快 0.01 秒执行，助您精准入场与出场。',
  'platform.ea': '智能交易（EA）',
  'platform.atc': '支持自定义 EA 与算法策略的自动化交易能力。',
  'platform.rm': '风险管理',
  'platform.crm': '提供止损、止盈及仓位控制等全面风险管理工具。',
  'platform.mpa': '多平台访问',
  'platform.tsa': '桌面、网页与移动平台无缝交易，账户同步访问。',
  'platform.gm': '全球市场',
  'platform.ati': '接入包括贵金属、外汇、指数与大宗商品等国际市场。',
  'platform.etw': '体验世界最先进的交易平台。以机构级技术与闪电级执行交易贵金属、外汇与差价合约。',
  'platform.download': '下载 ',
  'platform.wd': '观看示范',
  'platform.es': '执行速度',
  'platform.th': '交易时间',
  'platform.in': '交易品种',
  'platform.lt': '真实交易',
  'platform.ptt': '专业交易工具',
  'platform.aig': '为专业交易者与严谨投资者提供机构级工具',
  'platform.rtd': '实时数据',
  'platform.lmd': '实时市场数据与价格更新',
  'platform.pa': '价格提醒',
  'platform.caf': '自定义价格波动与市场事件提醒',
  'platform.this': '交易历史',
  'platform.cth': '完整的交易历史与绩效分析',
  'platform.ec': '经济日历',
  'platform.suw': '紧贴重要经济事件',
  'platform.mw': '市场报价',
  'platform.rtp': '所有可交易品种的实时报价与市场深度',
  'platform.om': '订单管理',
  'platform.aot': '支持市价、限价、止损与移动止损等进阶订单',
  'platform.ta': '技术分析',
  'platform.cta': '提供自定义指标与绘图工具的完整技术分析套件',
'platform.ffd': '适用于 Windows 10/11 的全功能桌面应用程序',
'platform.nma': '具有完整功能的原生 macOS 应用程序',
'platform.mta': '适用于 Android 设备的移动交易应用程序',
'platform.iai': 'iPhone 和 iPad 交易应用程序',
'hero.browseFAQ': '查看常见问题',
  'hero.contactSupport': '联系客户支持',

  'contactCTA.phoneTitle': '电话支持',
  'contactCTA.phoneDesc': '直接与我们的专员通话',
  'contactCTA.callNow': '立即致电',
  'contactCTA.emailTitle': '电邮支持',
  'contactCTA.emailDesc': '获取详细书面回复',
  'contactCTA.sendMsg': '发送消息',
  'contactCTA.chatTitle': '在线聊天',
  'contactCTA.chatDesc': '即时消息支持',
  'contactCTA.available': '24小时全年无休',
  'contactCTA.startChat': '开始聊天',
  'contactCTA.title': '还需要帮助吗？',
  'contactCTA.subtitle': '我们的专业客服团队随时为您提供协助。',

  'faq.tagline': '我们能如何帮助您？',
  'faq.title': '常见问题',
  'faq.subtitle': '浏览我们的常见问题，快速找到答案。',
  'faq.categories': '分类',
  'faq.cantFind': '找不到想要的答案？',
  'faq.supportText': '如常见问题未涵盖您的疑问，请联系我们的支持团队。',
  'faq.contactSupport': '联系支持团队',

  'faq.general': '一般问题',
  'faq.account': '账户',
  'faq.trading': '交易',
  'faq.platform': '平台',
  'faq.deposits': '入金与出金',
  'faq.security': '安全',

  'faq.general.q1': 'GOLD LABEL GLOBAL LIMITED 是什么公司？',
  'faq.general.a1': 'GOLD LABEL GLOBAL LIMITED 是一家位于香港的受监管贵金属交易公司，通过 MT5 平台提供黄金、白银及其他贵金属的专业交易服务。',
  'faq.general.q2': '你们提供哪些交易产品？',
  'faq.general.a2': '我们提供多种贵金属，包括现货黄金 (XAU/USD)、现货白银 (XAG/USD)、铂金、钯金及多种贵金属期货合约。',
  'faq.general.q3': '你们的交易时间是什么时候？',
  'faq.general.a3': '市场开放时间为每周 5 天、每天 24 小时，从星期日美东时间下午 5 点至星期五下午 4 点，遵循国际市场时间。',
  'faq.general.q4': '我的投资在贵公司安全吗？',
  'faq.general.a4': '是的，我们完全受监管并持牌经营。客户资金与公司资金分开存放，并享有完善的保险保障。',

  'faq.account.q1': '如何开立交易账户？',
  'faq.account.a1': '您可以在线填写申请表、提交身份证明文件并完成首次入金，通常 1–2 个工作日即可完成。',
  'faq.account.q2': '最低入金金额是多少？',
  'faq.account.a2': '标准账户最低入金为 1,000 美元，我们还提供高级账户以享受更多优惠。',
  'faq.account.q3': '我可以拥有多个交易账户吗？',
  'faq.account.a3': '可以，您可以开设多个不同货币或类型的账户，以适应不同交易策略与风险管理需求。',
  'faq.account.q4': '如何验证我的账户？',
  'faq.account.a4': '请提供政府签发的身份证明（护照或驾照）及三个月内的地址证明（如水电费账单或银行对账单）。',

  'faq.trading.q1': '最小交易手数是多少？',
  'faq.trading.a1': '大多数产品的最小交易单位为 0.01 手，方便灵活控制仓位与风险。',
  'faq.trading.q2': '你们提供多少杠杆？',
  'faq.trading.a2': '贵金属交易最高杠杆为 1:100，帮助您扩大交易潜力，同时保持稳健风险控制。',
  'faq.trading.q3': '有交易手续费吗？',
  'faq.trading.a3': '我们采用点差模式，无额外佣金，点差透明无隐藏费用。',
  'faq.trading.q4': '可以使用自动交易策略吗？',
  'faq.trading.a4': '可以，MT5 平台支持智能交易系统 (EA) 及自动化策略，您可自行开发或使用现成策略。',

  'faq.platform.q1': '支持哪些交易平台？',
  'faq.platform.a1': '我们主要使用 MetaTrader 5 (MT5) 平台，支持 Windows、Mac、iOS、Android 及网页版。',
  'faq.platform.q2': 'MT5 是否收费？',
  'faq.platform.a2': 'MT5 完全免费使用，包含所有图表与交易工具。',
  'faq.platform.q3': '能在手机上交易吗？',
  'faq.platform.a3': '当然可以！MT5 手机版支持 iOS 与 Android，让您随时随地掌握市场。',
  'faq.platform.q4': '是否提供模拟账户？',
  'faq.platform.a4': '我们提供免费模拟账户及虚拟资金，方便您练习和熟悉平台。',

  'faq.deposits.q1': '接受哪些入金方式？',
  'faq.deposits.a1': '支持银行转账、信用卡 (Visa、MasterCard) 及多种电子支付方式，安全高效。',
  'faq.deposits.q2': '入金多久到账？',
  'faq.deposits.a2': '信用卡入金通常即时到账，银行转账需 1–3 个工作日，电子支付一般数小时内完成。',
  'faq.deposits.q3': '是否收取入金手续费？',
  'faq.deposits.a3': '我们不收取入金费用，但银行或支付机构可能收取处理费。',
  'faq.deposits.q4': '如何提款？',
  'faq.deposits.a4': '请在客户后台申请提款，资金将退回原入金方式，处理时间依渠道而定。',

  'faq.security.q1': '如何保护我的个人信息？',
  'faq.security.a1': '我们使用 256 位 SSL 加密保护数据安全，并严格保密客户信息，不向第三方披露。',
  'faq.security.q2': '是否提供双重验证？',
  'faq.security.a2': '是的，建议启用两步验证 (2FA) 以提高账户安全。',
  'faq.security.q3': '忘记密码怎么办？',
  'faq.security.a3': '请点击登录页的“忘记密码”链接，我们会发送重置邮件帮助您重设密码。',
  'faq.security.q4': '如何确保公平交易环境？',
  'faq.security.a4': '我们提供实时报价、无人工干预，并严格遵守监管要求，确保交易公平透明。',

  'markets.specsTitle': '交易规则',
'markets.specsDisclaimer': '* 交易条件会因平台设置及市场流动性而调整。',
'markets.spreadTypeFloating': '浮动点差',
'markets.points': '点',
'markets.variableByMarket': '按市场变动',

'markets.table.symbol': '交易品种',
'markets.table.contractUnit': '合约单位',
'markets.table.minLot': '单笔最小交易量',
'markets.table.maxLot': '单笔最大交易量',
'markets.table.leverage': '杠杆',
'markets.table.spreadType': '点差类型',
'markets.table.avgSpread': '平均点差',
'markets.table.swapLong': '隔夜利息（多）',
'markets.table.swapShort': '隔夜利息（空）',


'markets.contractSections.contractSize.title': '合约大小',
'markets.contractSections.contractSize.items.xauusd.label': '黄金 (XAUUSD)',
'markets.contractSections.contractSize.items.xauusd.desc': '黄金交易标准合约大小',
'markets.contractSections.contractSize.items.xagusd.label': '白银 (XAGUSD)',
'markets.contractSections.contractSize.items.xagusd.desc': '白银交易标准合约大小',
'markets.contractSections.contractSize.items.gaucnh.label': 'GAUCNH',
'markets.contractSections.contractSize.items.gaucnh.desc': '离岸人民币相关外汇交易标准合约大小',

'markets.contractSections.priceMove.title': '最小价格变动',
'markets.contractSections.priceMove.items.goldTick.label': '黄金最小跳动',
'markets.contractSections.priceMove.items.goldTick.desc': '最小价格变动单位',
'markets.contractSections.priceMove.items.silverTick.label': '白银最小跳动',
'markets.contractSections.priceMove.items.silverTick.desc': '最小价格变动单位',
'markets.contractSections.priceMove.items.fxTick.label': '外汇最小跳动',
'markets.contractSections.priceMove.items.fxTick.desc': '货币对报价最小变动单位',

'markets.contractSections.settlement.title': '结算方式',
'markets.contractSections.settlement.items.type.label': '结算类型',
'markets.contractSections.settlement.items.type.value': '现金结算',
'markets.contractSections.settlement.items.type.desc': '无需实物交收',
'markets.contractSections.settlement.items.currency.label': '结算货币',
'markets.contractSections.settlement.items.currency.desc': '贵金属产品以美元结算',
'markets.contractSections.settlement.items.fxQuote.label': '报价货币',
'markets.contractSections.settlement.items.fxQuote.desc': 'GAUCNH 以 CNH 作报价',

'markets.contractSections.positionLimits.title': '持仓限制',
'markets.contractSections.positionLimits.items.maxPosition.label': '最大持仓',
'markets.contractSections.positionLimits.items.maxPosition.desc': '每个账户每个产品限制',
'markets.contractSections.positionLimits.items.orderDistance.label': '挂单距离',
'markets.contractSections.positionLimits.items.orderDistance.desc': '距离市价的最小距离',
'markets.contractSections.positionLimits.items.execution.label': '执行模式',
'markets.contractSections.positionLimits.items.execution.value': '市价执行',
'markets.contractSections.positionLimits.items.execution.desc': '订单会根据市场流动性执行',

'markets.days.monday': '星期一',
'markets.days.tuesday': '星期二',
'markets.days.wednesday': '星期三',
'markets.days.thursday': '星期四',
'markets.days.friday': '星期五',
'markets.days.saturday': '星期六',
'markets.days.sunday': '星期日',

'markets.hours.monThu': '06:00 - 04:59',
'markets.hours.friday': '06:00 - 04:57',
'markets.hours.closed': '休市',

'markets.holidays.newYear.date': '1月1日',
'markets.holidays.newYear.event': '元旦',
'markets.holidays.christmas.date': '12月25日',
'markets.holidays.christmas.event': '圣诞节',
'markets.holidays.independence.date': '7月4日',
'markets.holidays.independence.event': '美国独立日',
'markets.holidays.thanksgiving.date': '11月24日',
'markets.holidays.thanksgiving.event': '感恩节',

'news.pageTitle': '财经新闻',
'news.pageDesc': '精选黄金、市场、利率与央行动向，支持繁中、简中及英文内容切换。',
'news.searchPlaceholder': '搜索新闻关键词',
'news.empty': '暂无符合条件的新闻',
'news.filter.all': '全部',
'news.filter.gold': '黄金',
'news.filter.markets': '市场',
'news.filter.rates': '利率',
'news.filter.centralBank': '央行',
'news.filter.logistics': '物流',


// License Page
  'license.hero.badge': '官方认证资质',
  'license.hero.title': '香港黄金交易所行员牌照',
  'license.hero.subtitle': 'GOLD Label Global Limited 持有香港黄金交易所10号行员资格，受官方认可及监管，为您的贵金属交易提供最可靠的保障。',
  'license.hero.badge1': '官方持牌行员',
  'license.hero.badge2': '10号行员资格',
  'license.hero.badge3': '香港政府认可',

  'license.details.badge': '牌照详情',
  'license.details.title': '我们的官方牌照',
  'license.details.subtitle': '正式持牌，受香港黄金交易所监管，为客户提供最高标准的贵金属交易服务',

  'license.image.label': '官方牌照文件',
  'license.image.placeholder': '牌照图片',
  'license.image.desc': '香港黄金交易所官方行员牌照',
  'license.image.verified': '经香港黄金交易所官方认证',

  'license.member.label': '行员编号',
  'license.member.title': '香港黄金交易所行员',

  'license.info.title': '关于我们的行员资格',
  'license.info.desc1': 'GOLD Label Global Limited 是香港黄金交易所的正式行员，持有10号行员资格。香港黄金交易所是香港历史最悠久、规模最大的贵金属交易机构，成立超过100年，是全球最重要的黄金交易中心之一。',
  'license.info.desc2': '作为正式行员，我们严格遵守香港黄金交易所的所有规则及监管要求，确保每一笔交易均在透明、公平及安全的环境下进行，保障每位客户的利益。',

  'license.info.org.label': '监管机构',
  'license.info.org.value': '香港黄金交易所（Chinese Gold & Silver Exchange Society）',
  'license.info.member.label': '行员编号',
  'license.info.member.value': '第 10 号行员',
  'license.info.jurisdiction.label': '监管地区',
  'license.info.jurisdiction.value': '香港特别行政区',
  'license.info.status.label': '牌照状态',
  'license.info.status.value': '有效及合规',

  'license.features.title': '行员资格的意义',
  'license.features.official.title': '官方认可',
  'license.features.official.desc': '获香港黄金交易所正式认可，符合所有监管要求及行业标准',
  'license.features.trading.title': '正规交易资格',
  'license.features.trading.desc': '持有合法贵金属交易业务资格，可合规开展黄金白银交易业务',
  'license.features.regulated.title': '受严格监管',
  'license.features.regulated.desc': '受香港黄金交易所严格监管，定期接受合规审查及审计',
  'license.features.international.title': '国际认受性',
  'license.features.international.desc': '香港黄金交易所行员资格在全球范围内获广泛认可，具备国际公信力',
  'license.features.market.title': '市场准入',
  'license.features.market.desc': '可直接参与香港黄金交易所的交易市场，获得最优质的市场流动性',
  'license.features.network.title': '行业网络',
  'license.features.network.desc': '成为庞大行业网络的一部分，与其他正规金融机构建立可靠合作关係',

  'license.exchange.badge': '关于香港黄金交易所',
  'license.exchange.title': '香港黄金交易所 — 逾百年传承',
  'license.exchange.desc1': '香港黄金交易所（Chinese Gold & Silver Exchange Society）成立于1910年，是香港历史最悠久的贵金属交易机构。逾百年来，交易所一直是香港乃至亚洲贵金属市场的核心机构。',
  'license.exchange.desc2': '交易所设立严格的会员资格制度，只有符合资格、通过审核的企业才能成为正式行员。我们公司成功获得10号行员资格，充分证明了我们的专业实力及信誉。',

  'license.exchange.stat1.value': '1910',
  'license.exchange.stat1.label': '交易所成立年份',
  'license.exchange.stat2.value': '100+',
  'license.exchange.stat2.label': '年历史传承',
  'license.exchange.stat3.value': 'HK$800亿',
  'license.exchange.stat3.label': '日均交易额',
  'license.exchange.stat4.value': '全球认可',
  'license.exchange.stat4.label': '国际公信力',

  'license.exchange.img.caption': '香港黄金交易所',
  'license.exchange.img.sub': 'Chinese Gold & Silver Exchange Society',
  'license.exchange.badge.number': '第10号行员',
   "hero.cta.accountOpening": "开户流程",
  "hero.cta.depositWithdraw": "出入金流程",
  "androidDownload.title": "下载 MetaTrader 5",
  "androidDownload.description": "系统会自动为你前往 Google Play。如果你的设备无法使用 Google Play，也可以直接下载 APK。",
  "androidDownload.autoRedirect": "{{seconds}} 秒后自动前往 Google Play",
  "androidDownload.openGooglePlay": "打开 Google Play",
  "androidDownload.downloadApk": "直接下载 APK",
  "androidDownload.hint": "如果 Google Play 未能打开，请点击“直接下载 APK”。",
  'windowsDownload.pageTitle': 'Windows MT5 安装下载',
  'windowsDownload.pageDesc': '请在弹页中选择适合您的下载版本。',
  'windowsDownload.badge': 'Windows MT5 安装下载',
  'windowsDownload.title': '请选择适合您的安装包',
  'windowsDownload.description': '请选择适合您的 Windows MT5 安装包。金利宝流畅稳定版适合中国内地及香港用户优先使用；如需使用原有官方安装包，也可选择第二项。',
  'windowsDownload.smoothTitle': '1、金利宝流畅稳定版',
  'windowsDownload.smoothDesc': '适合中国内地 / 香港 Windows 用户，建议优先下载此版本。其他地区用户如遇官方安装包不便，也可使用。',
  'windowsDownload.smoothButton': '下载金利宝流畅稳定版',
  'windowsDownload.officialTitle': '2、直达迈达克官方安装包',
  'windowsDownload.officialDesc': '原有下载链接。大陆地区 Windows 用户偶尔会出现无法安装情况，其他地区客户不受影响。',
  'windowsDownload.officialButton': '下载官方安装包',

  // Economic calendar explorer
  'calendar.hongKongTime': '香港时间（GMT+8）',
  'calendar.previousDays': '前 7 天',
  'calendar.nextDays': '后 7 天',
  'calendar.today': '今天',
  'calendar.jumpToDate': '跳转到日期',
  'calendar.completeView': '完整日历',
  'calendar.allDays': '全部 7 天',
  'calendar.events': '事件',
  'calendar.impactAll': '全部重要性',
  'calendar.impactHigh': '高',
  'calendar.impactMedium': '中',
  'calendar.impactLow': '低',
  'calendar.searchPlaceholder': '搜索事件、国家或货币',
  'calendar.eventsFound': '个事件显示中',
  'calendar.lastUpdated': '最后更新',
  'calendar.loadError': '暂时无法加载经济日历。',
  'calendar.noEvents': '此视图没有符合条件的经济事件。',
  'calendar.tryAnotherDate': '请选择其他日期或清除筛选条件。',
  'calendar.time': '时间',
  'calendar.impact': '重要性',
  'calendar.released': '已公布',
  'calendar.pending': '待公布',
  'calendar.disclaimer': '日历时间以香港时间显示；数据可能修订，内容仅供参考。',
  'news.tab.newsDesc': '最新市场新闻、黄金分析及教育内容',
  'news.tab.calendarDesc': '查看前后日期的重要经济事件及公布数据',
  'news.autoRefresh': '新闻资料会自动更新',

  'news.tabs.news': '新闻',
  'news.tabs.calendar': '经济日历',

};

export default common;
